import { AlertCircle } from 'lucide-react';

import { isApiError } from '@/lib/api-errors';

/**
 * The one refusal that applies to the whole form rather than a single field — a wrong
 * password, a suspended account, an expired link.
 *
 * Placed above the submit button rather than at the top of the card, because that is
 * where the person is looking when the form comes back.
 */
export const FormError = ({ error }: { error: unknown }) => {
  if (!error) return null;

  const message = isApiError(error) ? error.message : null;
  if (!message) return null;

  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded-md border border-danger/30 bg-danger/5 px-3 py-2 text-body-sm text-danger"
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0" aria-hidden />
      <span>{message}</span>
    </div>
  );
};
